<div id="academy-courses" class="page-layout simple">


    <!-- CONTENT -->
    <div class="content p-24">

        <div fxLayout="column" fxLayoutAlign="center">
            <app-top-search-bar [onSearchCallback]="filterCardsByTerm"></app-top-search-bar>

            <div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
                <ng-template #cards_holder></ng-template>
            </div>
        </div>
    </div>
    <!-- / CONTENT -->

</div>